import { render, staticRenderFns } from "./projectReviewApply.vue?vue&type=template&id=d2a8f0a8&scoped=true"
import script from "./projectReviewApply.vue?vue&type=script&lang=js"
export * from "./projectReviewApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a8f0a8",
  null
  
)

export default component.exports